module.exports = __webpack_public_path__ + "img/ideation-02-bg-intro.4b78694e.jpg";